<form #f="ngForm" [formGroup]="AttachForm" (ngSubmit)="AttachForm.valid && InsAttachment()" method="post"
    autocomplete="off" style="padding:20px;">
    <div>
        <div>
            <div class="row" style="width:100%;">
                <ng-container *ngFor="let ls of screenData">
                <div class="col-sm-3" *ngIf="ls.ctrl_id == 'title'">
                    <!-- <input type="text" name="attchment" id="attachment" class="form-control" placeholder="Attachment ID"
                        readonly=""> -->
                </div>
                <div class="col-sm-4" *ngIf="ls.ctrl_id == 'title'">
                    <h4 style="font-size: 15px;text-align: center;color: #1a9950;font-weight: 600;">{{ls.label_desc}}</h4>
                </div>
                <div class="col-sm-5" *ngIf="ls.ctrl_id == 'title'">
                    <div style="float:right;">
                        <button (click)="closeModal(); AttachClear()" style="border: unset;background: white;">
                            <svg class="svg-inline--fa fa-times fa-w-11" aria-hidden="true"
                                style="color: #000;font-size: 20px;cursor: pointer;" data-prefix="fa" data-icon="times"
                                role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" data-fa-i2svg="">
                                <path fill="currentColor"
                                    d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
                                </path>
                            </svg>
                        </button>

                    </div>

                </div>
            </ng-container>
            </div>
            <div class="row">
                <ng-container *ngFor="let ls of screenData">
                    <div class="col-sm-3" *ngIf="ls.ctrl_id == '_doc_type_code'">
                        <label for="fponame">{{ls.label_desc}}</label>
                        <select placeholder="" class="form-control" formControlName="DocGroup" #DocGroup
                            (change)="DocGroupChange($event)">
                            <option value="" disabled selected>{{statusMsg.select}}</option>
                            <option *ngFor="let DocGroup of DocGroups" [value]="DocGroup.master_code">
                                {{DocGroup.master_desc}}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-3" *ngIf="ls.ctrl_id == '_doc_subtype_code'">
                        <label for="fponame">{{ls.label_desc}}</label>
                        <select placeholder="" class="form-control" formControlName="SubGroup" #SubGroup>
                            <option value="" disabled selected>{{statusMsg.select}}</option>
                            <option *ngFor="let SubGroup of SubGroups" [value]="SubGroup.master_code">
                                {{SubGroup.master_desc}}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-6" *ngIf="ls.ctrl_id == '_file_name'">
                        <label for="fponame">{{ls.label_desc}}</label>
                        <div class="input-group mb-3">
                            <input *ngIf="mode != 'View'" (change)="onFileChange($event)" formControlName="file"
                                type="file" class="form-control" id="fname" name="fname">
                            <input *ngIf="mode == 'View'" readonly formControlName="file" type="file"
                                class="form-control" id="fname" name="fname">
                        </div>
                        <div *ngIf="errmsg != ''"> <small class="text-danger">{{errmsg}}</small>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="row">
                <ng-container *ngFor="let ls of screenData">
                    <div class="col-sm-6" *ngIf="ls.ctrl_id == '_attachment_remark'">
                        <label for="fponame">{{ls.label_desc}}</label>
                        <input type="text" formControlName='Remark' id="Remark" class="form-control">
                    </div>
                

                <div class="form-check-inline" style="width: 48%; display: flex; align-items: center; justify-content: left; margin-top: 22px;" *ngIf="ls.ctrl_id == 'is_verified'">
                    <label class="form-check-label">
                      <input style="margin-right:10px;" type="checkbox" class="form-check-input"
                      formControlName="original_verified_flag"> {{ls.label_desc}}
                    </label>
                  </div>
                </ng-container>
            </div>

        </div>
        <!--Grid Data Binding-->
        <div class="container" style="margin-top:10px;margin-left:-14px;">
            <div class="row" style="width:109%;">
                <div class="col-sm-12">
                    <div class="mrT-20">

                        <kendo-grid [data]="gridView" [sortable]="{
                 allowUnsort: allowUnsort,
                 mode: multiple ? 'multiple' : 'single'
               }" [filter]="state.filter" filterable="menu" (sortChange)="sortChange($event)"
                            (dataStateChange)="dataStateChange($event)" [columnMenu]="{ filter: true }" [skip]="skip"
                            [pageSize]="pageSize" [pageable]="true" [pageable]="{
                 buttonCount: buttonCount,
                 info: info,
                 type: type,
                 pageSizes: pageSizes,
                 previousNext: previousNext,
                 position: position
               }" (pageChange)="pageChange($event)" style="margin-right: 3% !important;
               margin-left: -1% !important;">
                            <ng-container *ngFor="let ls of screenData">
                                <kendo-grid-column *ngIf="ls.data_field == 'doc_type_desc'" field="{{ls.data_field}}"
                                    title="{{ls.label_desc}}" width="120" [style]="{ 'text-align': 'left' }">
                                </kendo-grid-column>
                                <kendo-grid-column *ngIf="ls.data_field == 'doc_subtype_desc'" field="{{ls.data_field}}"
                                    title="{{ls.label_desc}}" width="120" [style]="{ 'text-align': 'left' }">
                                </kendo-grid-column>
                                <kendo-grid-column *ngIf="ls.data_field == 'file_name'" field="{{ls.data_field}}"
                                    title="{{ls.label_desc}}" width="180" [style]="{ 'text-align': 'left' }">
                                </kendo-grid-column>
                                <kendo-grid-column *ngIf="ls.data_field == 'attachment_remark'"
                                    field="{{ls.data_field}}" title="{{ls.label_desc}}" width="180"
                                    [style]="{ 'text-align': 'left' }"></kendo-grid-column>
                            </ng-container>

                            <kendo-grid-column [columnMenu]="false" class="no-border" field="a" title="" width="80"
                                [style]="{'border' : 'unset', 'background' : 'white', 'text-align': 'left' }"
                                [headerStyle]="{'border' : 'unset', 'background' : 'white'}">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    &nbsp;
                                    <a (click)="download(dataItem)" style="cursor: pointer;">
                                        <svg class="svg-inline--fa fa-download fa-w-16"
                                            style="color: #246141;font-size: 12px;" aria-hidden="true" data-prefix="fa"
                                            data-icon="download" role="img" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512" data-fa-i2svg="">
                                            <path fill="currentColor"
                                                d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z">
                                            </path>
                                        </svg>
                                    </a>&nbsp;&nbsp;&nbsp;
                                </ng-template>
                            </kendo-grid-column>
                        </kendo-grid>
                    </div>
                </div>
            </div>
        </div>

    </div>
</form>

<!--/Grid Data Binding-->